import React from 'react'
import xtensiv from '../../../../assets/Extensiv.webp'
import { PurchaseOrderTable } from './PurchaseOrderTable'
import AppShell from '../../../../Components/AppShell'
import PageHeader from '../../../../Components/PageHeader'

const ExtensivToolsPOView = () => {
  return (
    <AppShell>
      <PageHeader
        kicker="Warehouse"
        title="Purchase order converter"
        subtitle="Convert Extensiv purchase order files for import."
        crumbs={[
          { label: 'Home', to: '/home' },
          { label: 'Warehouse', to: '/warehouse-tools' },
          { label: 'Extensiv PO' },
        ]}
        status={
          <div className="h-8 w-28">
            <img className="h-full w-full object-contain" src={xtensiv} alt="Extensiv" />
          </div>
        }
      />
      <div className="nx-panel overflow-hidden p-2 sm:p-4">
        <PurchaseOrderTable />
      </div>
    </AppShell>
  )
}

export default ExtensivToolsPOView
